import { login, logout, fetchAdminMenuAndBtn, queryDetailById } from '@/api/httpData';
import { setToken, removeToken, getToken } from '@/utils/auth';
// import { resetRouter } from '@/router';
import { flattenArray } from '@/utils/common';
// import { queryAgencyMobile,javaAndPhp } from '@/api/merchant'

const getDefaultState = () => {
  return {
    name: '',
    avatar: '',
    userInfo: '',
    account: '',
    admin: false,
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER_INFO: (state, payload) => {
    state.avatar = payload.avatar;
    state.name = payload.name;
    state.userInfo = {
      userId: payload.id,
      mobile: payload.telephone,
    };
  },
  SET_USER_ACCOUNT: (state, payload) => {
    state.account = {
      projectId: payload.projectId,
      agencyId: payload.agencyId,
      shopId: payload.shopId,
    };
  },
  SET_AVATAR: (state, payload) => {
    state.avatar = payload;
  },
  SET_ADMIN: (state, payload) => {
    state.admin = payload;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ grantType:"1",userName: account.trim(), password: password })
        .then(response => {
          commit('SET_TOKEN', response.data.token);
          commit('SET_USER_INFO', {id: response.data.userId,telephone:response.data.mobile});
          commit('SET_USER_ACCOUNT', response.data);
           setToken('G_Life_Token', response.data.token);
          setToken('userInfo', JSON.stringify({ id: response.data.userId,userRole: response.data.userRole }));
          
          resolve();
          
          
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get menu info
  getMenuInfo({ commit }) {
    return new Promise(async (resolve, reject) => {
      let userInfo = getToken('userInfo') || {};
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
      }
      try {
        const user = await queryDetailById({ id: userInfo.id });
        // const menuList = await fetchAdminMenuAndBtn({ id: user.id});
        
        // if (!menuList) {
        //   reject([]);
        //   return;
        // }
        commit('SET_USER_INFO', {
          avatar: user.data.headPath,
          name: user.data.name,
          id: user.data.id,
          account: user.data.userName,
          agencyName: user.data.agencyName,
          telephone: user.data.mobile,
          agencyId: user.data.agencyId,
          isPlatform: user.data.isPlatform
        });
        let account = {
          projectId: user.data.projectId,
          agencyId: user.data.agencyId,
          shopId: user.data.shopId,
          projectName: user.data.projectName,
          agencyName: user.data.agencyName,
          shopName: user.data.shopName,
          isPlatform: user.data.isPlatform
        };
        setToken('account', JSON.stringify(account));
         resolve();
      } catch (err) {
        console.log(err);
        reject([]);
      }
    });
  },

  getUserInfo({ commit, state }) {
    queryDetailById({ id: state.userInfo.userId }).then(response => {
      let account = {
        projectId: response.projectId,
        agencyId: response.agencyId,
        shopId: response.shopId,
        projectName: response.projectName,
        agencyName: response.agencyName,
        shopName: response.shopName,
      };
      if(response.projectId === '1' && response.agencyId === '1' && response.shopId === '1') {
        commit('SET_ADMIN', true);
      } else {
        commit('SET_ADMIN', false);
      }
      setToken('account', JSON.stringify(account));
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout({}, {allData: true})
      //   .then((res) => {
      //     if(res.success) {
      //       removeToken('G_Life_Token'); // must remove  token  first
      //       removeToken('userInfo'); // must remove  token  first
      //       removeToken('account'); // must remove  token  first
      //       resetRouter();
      //       commit('RESET_STATE');
  
      //       dispatch('tagsView/delAllViews', null, { root: true });
      //       resolve();
      //     }

      //   })
      //   .catch(error => {
      //     reject(error);
      //   });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken('G_Life_Token'); // must remove  token  first
      commit('RESET_STATE');
      resolve();
    });
  },
  setAvatar({ commit }, payload) {
    commit('SET_AVATAR', payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
